import { Box } from "@mui/material";
import { useOutletContext } from "react-router-dom";

import { InsightsAsset } from "graphql-types/graphql";
import { useAssetStore } from "legacyNext/store/asset-page-store";

import { ReductionAnalysisView, ReductionPlanView } from "../views";

export const Sustainability = () => {
    const { asset } = useOutletContext<{ asset: InsightsAsset }>();

    const { proposals, setProposals } = useAssetStore();

    const onProposalChange = (
        id: string,
        key: "startYear" | "enabled",
        value: number | boolean | null
    ) => {
        const updatedProposals = proposals.map((proposal) =>
            proposal.id === id ? { ...proposal, [key]: value } : proposal
        );

        setProposals(updatedProposals);
    };

    return (
        <Box>
            <ReductionAnalysisView
                assetId={asset.id}
                proposals={proposals}
                area={asset.area ?? null}
            />
            <ReductionPlanView
                proposals={proposals}
                onChange={onProposalChange}
            />
        </Box>
    );
};
